import { AnimationFrameAction } from './AnimationFrameAction';
import { AnimationFrameScheduler } from './AnimationFrameScheduler';
export const animationFrameScheduler = new AnimationFrameScheduler(AnimationFrameAction);
export const animationFrame = animationFrameScheduler;
//# sourceMappingURL=animationFrame.js.map